import React from 'react';
import styled from 'styled-components';
import DashboardHeader from '../components/dashboard/DashboardHeader';
import DashboardFooter from '../components/dashboard/DashboardFooter';

const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const PageContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px;
  flex: 1;
`;

const PageTitle = styled.h1`
  font-size: 32px;
  color: #2c3e50;
  margin-bottom: 30px;
  text-align: center;
`;

const ContentCard = styled.div`
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`;

const Webinar = () => {
  return (
    <PageWrapper>
      <DashboardHeader />
      <PageContainer>
        <PageTitle>Вебинар</PageTitle>
        <ContentCard>
          <h2>Обучающие вебинары</h2>
          <p>Здесь будут размещены записи вебинаров, расписание предстоящих занятий и обучающие материалы.</p>
        </ContentCard>
      </PageContainer>
      <DashboardFooter />
    </PageWrapper>
  );
};

export default Webinar; 